import type { OrderStep } from '@/types/supervisor';

export type StepLeaveGuardSource = 'stepRibbon';

export interface StepLeaveGuardRequest {
  readonly source: StepLeaveGuardSource;
  readonly targetStep: OrderStep;
}

type StepLeaveGuardHandler = (request: StepLeaveGuardRequest) => boolean | Promise<boolean>;

let activeGuard: StepLeaveGuardHandler | null = null;

export const registerStepLeaveGuard = (guard: StepLeaveGuardHandler): (() => void) => {
  activeGuard = guard;

  return () => {
    if (activeGuard === guard) {
      activeGuard = null;
    }
  };
};

export const requestStepLeave = async (request: StepLeaveGuardRequest): Promise<boolean> => {
  if (!activeGuard) {
    return true;
  }

  return Promise.resolve(activeGuard(request));
};
